import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { TextTypes } from '@/widgets/Text/Text';

export function createNewTextData(
  content: string,
  textType: TextTypes,
  withParagraphOption = true
): ManifestInitializedProps {
  const id = genRandId();
  const fragment = htmlToXmlFragment(content);
  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.Text],
        ['textType', textType],
        ['withParagraphOption', withParagraphOption],
        ['children', new Y.Array()],
        ['fragment', fragment],
        ['placeholder', ''],
        ['style', new Y.Map()]
      ])
    }
  ];
}
